import { useFieldArray, useFormContext } from "react-hook-form";
import { CardView } from "../../../../../_components/Abstractions/CardView";
import { HorizontalView } from "../../../../../_components/Abstractions/HorizontalView";
import { NumericControl } from "../../../../../_components/Forms/NumericControl";
import { ContractorServiceSelect } from "../../../../../_components/ContractorServices/ContractorServiceSelect";
import { DomainSwitch } from "../../../../../_components/Abstractions/DomainSwitch";
import { FormControl } from "../../../../../_components/Forms/FormControl";
import { useEffect, useState } from "react";
import { WastesKindsMultiSelect } from "../WastesKindsMultiSelect";
import { RATE_PLAN_TYPE } from "../../../../../domain/RatePlanType";

export function ServicesRatePlanForm() {
  const { fields, replace, remove } = useFieldArray({ name: "services" });
  const { getFieldState, getValues, watch, resetField } = useFormContext();
  const fieldState = getFieldState("services");
  const purchaseServices = getValues("purchaseServices");
  const saleServices = getValues("saleServices");
  const purchaseContractorServices = getValues("purchaseContractorServices");
  const saleContractorServices = getValues("saleContractorServices");
  const isUpdate = getValues("isUpdate");
  const isClone = getValues("isClone");
  const type = watch("type");
  const addressId = watch("addressId");
  const addressesIds = watch("addressesIds");
  const [isCurrentAddressEmpty, setIsCurrentAddressEmpty] = useState(true);
  const multipleRatePlans = watch("multipleRatePlans");

  const [currentType, setCurrentType] = useState(null);

  const isAddressEmpty = (address) => !address || address === "";

  useEffect(() => {
    const isNewAddressEmpty = isAddressEmpty(addressId);

    if(isUpdate || isClone || ((isNewAddressEmpty && isCurrentAddressEmpty) && currentType === type) || multipleRatePlans) {
      return;
    }

    setCurrentType(type);
    setIsCurrentAddressEmpty(isNewAddressEmpty)

    if(!type || type === "") {
      replace([]);
      return;
    }

    if(isNewAddressEmpty) {
      const contractorServices = type === RATE_PLAN_TYPE.PURCHASE ? purchaseContractorServices : saleContractorServices;
      replace(contractorServices);
      return;
    }

    const usedServices = type === RATE_PLAN_TYPE.PURCHASE ? purchaseServices : saleServices;
    const usedServicesForAddress = usedServices[addressId]?.map(x => ({ serviceId: x.serviceId, service: x }));
    replace(usedServicesForAddress);
  }, [type, addressId]);

  useEffect(() => {
    if (!multipleRatePlans) {
      return;
    }

    if(!type || type === "") {
      replace([]);
      return;
    }
    const usedServices = type === RATE_PLAN_TYPE.PURCHASE ? purchaseServices : saleServices;
    const servicesForRatePlan = groupByWasteKindForAddresses(addressesIds, usedServices);
    replace(servicesForRatePlan);

  }, [multipleRatePlans, addressesIds]);

  return <>
    <CardView headerText="Usługi" headerTypo="h5">
      <div className="domain-control error mb-2">{fieldState?.error?.message}</div>
      {fields?.length === 0 && <i>Brak usług dla danego adresu / kontrahenta</i>}
      {fields?.map((waste, index) => (
        <ServiceRatePlanForm key={waste.id} index={index} onRemove={remove}/>
      ))}
      {/*<DomainButton onClick={addItem}>Dodaj usługę</DomainButton>*/}
    </CardView>
  </>;
}

const ServiceRatePlanForm = ({ index }) => {
  const GetFieldName = (fieldName, index) => `services[${index}].${fieldName}`;
  const GetWasteFieldName = (fieldName, wasteIndex) =>
    `${GetFieldName("wasteAdvancedPricing", index)}[${wasteIndex}].${fieldName}`;
  const { watch, setValue, getValues } = useFormContext();
  const addressId = watch("addressId");
  const isAdvancedPricing = watch(GetFieldName("isAdvancedPricing", index))
  const isWasteAdvancedPricing = watch(GetFieldName("isWasteAdvancedPricing", index))
  const wasteAdvancedPricing = watch(GetFieldName("wasteAdvancedPricing", index))

  useEffect(() => {
    if(!isWasteAdvancedPricing) {
      setValue(GetFieldName("wasteAdvancedPricing", index), [])
      return;
    }

    if (Object.entries(wasteAdvancedPricing ?? {}).length > 0) {
      return;
    }

    const wastes = getValues("wastes");
    const wastesAdvancedPricing = wastes?.map(x => ({
      wasteKey: x.wasteKind?.wasteKindId ?? x.waste?.wasteId,
      wasteId: x.waste?.wasteId,
      wasteKindName: x.wasteKindName,
      wasteKindId: x.wasteKind?.wasteKindId,
      displayDescription: x.waste?.displayDescription
    }))
    setValue(GetFieldName("wasteAdvancedPricing", index), wastesAdvancedPricing)

  }, [isWasteAdvancedPricing]);

  return <>
    <HorizontalView columnsSize={[7, 3, 2]}>
      {/*<WastesSelect name={GetFieldName("waste", index)} label="Towar" skipInitLoading readonly={isPurchase}/>*/}
      <ContractorServiceSelect name={GetFieldName("service", index)} label="Usługa" readonly/>
      {/*<FormControl name={GetFieldName("wasteKindName", index)} label="Gatunek" readonly required={false} />*/}
      {!isAdvancedPricing && !isWasteAdvancedPricing && <NumericControl name={GetFieldName("price", index)} label="Cena" required={false}/>}
      {/*{!isPurchase && <DomainButton size="large" onClick={() => onRemove(index)} className="mt-2">Usuń</DomainButton>}*/}
    </HorizontalView>
    <div className="d-flex gap-3">
      <DomainSwitch name={GetFieldName("isAdvancedPricing", index)} label="Zaawansowany cennik usług"></DomainSwitch>
      <DomainSwitch name={GetFieldName("isWasteAdvancedPricing", index)} label="Zaawansowany cennik towarów"></DomainSwitch>
    </div>
    {isAdvancedPricing && !isWasteAdvancedPricing && <HorizontalView columnsSize={[3, 3, 3]}>
      <NumericControl name={GetFieldName("priceTon", index)} label="Cena / T" required={false}/>
      <NumericControl name={GetFieldName("priceUnit", index)} label="Cena / szt." required={false}/>
      <NumericControl name={GetFieldName("priceRunningMeter", index)} label="Cena / mb." required={false}/>
    </HorizontalView>}
    {isWasteAdvancedPricing && <div>
      <div className="mb-2">
        <WastesKindsMultiSelect
          name={GetFieldName("wasteAdvancedPricing", index)}
          optionSave={(x) => x}
          required={false}
          // isAddressIdRequired
          resetOnReadonlyChange
          skipFieldsTrack={false}
          addressId={addressId}
          skipInitLoading
        />
      </div>
      {wasteAdvancedPricing?.map((waste, wasteIndex) =>
        (<div key={waste.wasteKey}>
          <HorizontalView columnsSize={[7,3,2]}>
            <FormControl name={GetWasteFieldName("displayDescription", wasteIndex)} label="Towar" readonly/>
            <FormControl name={GetWasteFieldName("wasteKindName", wasteIndex)} label="Gatunek" readonly required={false}/>
            {!isAdvancedPricing && <NumericControl name={GetWasteFieldName("price", wasteIndex)} label="Cena"/>}
          </HorizontalView>
          {isAdvancedPricing && <HorizontalView columnsSize={[3, 3, 3]}>
            <NumericControl name={GetWasteFieldName("priceTon", wasteIndex)} label="Cena / T"/>
            <NumericControl name={GetWasteFieldName("priceUnit", wasteIndex)} label="Cena / szt."/>
            <NumericControl name={GetWasteFieldName("priceRunningMeter", wasteIndex)} label="Cena / mb."/>
          </HorizontalView>}
        </div>))}
    </div>}
  </>
}

const groupByWasteKindForAddresses = (addressesIds, usedServicesForAddresses) => {
  const results = [];
  const seen = new Set();
  addressesIds?.forEach(addressId => {
    const services = usedServicesForAddresses[addressId] || [];
    services.forEach(service => {
      const serviceId = service.serviceId;
        if (!seen.has(serviceId)) {
          seen.add(serviceId);
          results.push({ serviceId: serviceId, service: service });
        }
    });
  });

  return results;
};
